"use strict";

var _classCallCheck = require("C:\\Users\\vanro\\Desktop\\react-projects\\Portfolio\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\vanro\\Desktop\\react-projects\\Portfolio\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PolygonMask = void 0;

var PolygonMaskDraw_1 = require("./PolygonMaskDraw");

var PolygonMaskInline_1 = require("./PolygonMaskInline");

var PolygonMaskLocalSvg_1 = require("./PolygonMaskLocalSvg");

var PolygonMaskMove_1 = require("./PolygonMaskMove");

var Utils_1 = require("../../../../Utils/Utils");

var PolygonMask = /*#__PURE__*/function () {
  function PolygonMask() {
    _classCallCheck(this, PolygonMask);

    this.draw = new PolygonMaskDraw_1.PolygonMaskDraw();
    this.enable = false;
    this.inline = new PolygonMaskInline_1.PolygonMaskInline();
    this.move = new PolygonMaskMove_1.PolygonMaskMove();
    this.scale = 1;
    this.type = "none";
  }

  _createClass(PolygonMask, [{
    key: "load",
    value: function load(data) {
      var _a;

      if (!data) {
        return;
      }

      this.draw.load(data.draw);
      var inline = (_a = data.inline) !== null && _a !== void 0 ? _a : {
        arrangement: data.inlineArrangement
      };

      if (inline !== undefined) {
        this.inline.load(inline);
      }

      this.move.load(data.move);

      if (data.scale !== undefined) {
        this.scale = data.scale;
      }

      if (data.type !== undefined) {
        this.type = data.type;
      }

      if (data.enable !== undefined) {
        this.enable = data.enable;
      } else {
        this.enable = this.type !== "none";
      }

      if (data.url !== undefined) {
        this.url = data.url;
      }

      if (data.data !== undefined) {
        if (typeof data.data === "string") {
          this.data = data.data;
        } else {
          this.data = new PolygonMaskLocalSvg_1.PolygonMaskLocalSvg();
          this.data.load(data.data);
        }
      }

      if (data.position !== undefined) {
        this.position = (0, Utils_1.deepExtend)({}, data.position);
      }
    }
  }, {
    key: "inlineArrangement",
    get: function get() {
      return this.inline.arrangement;
    },
    set: function set(value) {
      this.inline.arrangement = value;
    }
  }]);

  return PolygonMask;
}();

exports.PolygonMask = PolygonMask;